module.exports = __webpack_public_path__ + "img/K.6b3e90ce.jpg";